/**
 * FooterMain component.
 * @module components/Footer/FooterMain
 * Customizations:
 * - Removed FooterNavigation
 * - Added logos
 */

import React from 'react';
import { Container, Row, Col } from 'design-react-kit/dist/design-react-kit';

import { UniversalLink } from '@plone/volto/components';
import {
  // FooterNavigation,
  FooterInfos,
  LogoFooter,
  BrandTextFooter,
} from 'design-comuni-plone-theme/components/ItaliaTheme/';
import FooterLogosExtras from '@package/components/Footer/FooterLogosExtra';

/**
 * FooterMain component class.
 * @class FooterMain
 * @extends Component
 */
const FooterMain = () => {
  return (
    <div className="it-footer-main">
      <Container tag="div">
        <section>
          <Row className="clearfix" tag="div">
            <Col sm={12} tag="div" widths={['xs', 'sm', 'md', 'lg', 'xl']}>
              <div className="it-brand-wrapper">
                <UniversalLink href="/">
                  <LogoFooter />
                  <BrandTextFooter />
                </UniversalLink>
              </div>
            </Col>
          </Row>
        </section>

        {/* <section>
          <FooterNavigation />
        </section> */}
        <section className="py-4 border-white border-top">
          <FooterInfos />
        </section>
        <section className="py-4">
          <FooterLogosExtras />
        </section>
      </Container>
    </div>
  );
};

export default FooterMain;
